module.exports = __webpack_public_path__ + "static/media/cerave@3x.6b84a360.png";